import { Navigate, Outlet, Route, Routes } from 'react-router-dom'
import { useEffect } from 'react'
import RecalculateForm from './RecalculateForm'

const RecalculatePage = () => {
    useEffect(() => {
        document.title = 'PANEL | Reports'
    }, [])
    return (
        <>
            <Routes>
                <Route element={<Outlet />}>
                    <Route
                        path='recalculate'
                        element={
                            <RecalculateForm />
                        }
                    />
                </Route>

                <Route index element={<Navigate to='/report' />} />
            </Routes>
        </>
    )
}

export default RecalculatePage
